const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

if (canHover) {
  document.querySelectorAll('.case-studies__media').forEach((wrap) => {
    const video = wrap.querySelector('.case-studies__hover-video');

    if (!video) return;

    wrap.addEventListener('mouseenter', () => {
      video.play().catch(() => {});
    });

    wrap.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });
  });
}
